module.exports = __webpack_public_path__ + "img/translator__ch-en.ff864d4.svg";